module.exports = __webpack_public_path__ + "img/worker.0e236aaa.svg";